var map = {
	"./Accounting_trans_icon.png": 9144,
	"./Bookkeeping icon.png": 2941,
	"./Business_tran_icon.png": 8392,
	"./Payroll_trans_icon.png": 6494,
	"./accounting copy.png": 1374,
	"./accounting.png": 585,
	"./bookkeeping_trans.png": 3607,
	"./buiness_trans_icon.png": 9756,
	"./business.png": 6376,
	"./individule_trans_icon.png": 36,
	"./payroll.png": 9059,
	"./tax.png": 1491,
	"./tax_trans_icone.png": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9876;